<template>
  <div class="ma-2 pl-2 pr-2">
    <b-row>
      <b-col cols="12" class="mb-0 pb-0">
        <b-form-group :label="$t('views.surveys.form.questionDescription')">
          <b-form-input
            v-model="surveyQuestion.questionDescription"
            name="questionDescription"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" class="mt-2 pt-2">
        <b-form-group :label="$t('views.surveys.form.questionType')">
          <b-form-select
            v-model="surveyQuestion.questionType"
            :options="questionTypeOptions"
            value-field="value"
            text-field="text"
          >
            <!-- opcjonalny placeholder -->
            <template #first>
              <b-form-select-option :value="null" disabled>
                -- {{ $t('common.select') }} --
              </b-form-select-option>
            </template>
            <!-- w dropdownie: ikona + tekst -->
            <template #option="{ option }">
              <i v-if="option.icon" class="mr-2" :class="option.icon"></i>
              <span>{{ option.text }}</span>
            </template>
            <!-- w polu wybranej wartości: ikona + tekst -->
            <template #selected="{ option }">
              <i v-if="option && option.icon" class="mr-2" :class="option.icon"></i>
              <span>{{ option ? option.text : '' }}</span>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" class="mt-0 pt-0 mb-0 pb-0">
        <b-form-checkbox
          switch
          class="mt-0 pt-2 mb-0 pb-0"
          v-model="surveyQuestion.required"
          :value="1"
          :unchecked-value="0"
        >
          {{ $t('views.excmcasetype.form.customField.fieldRequired') }}
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="mt-0 pt-0">
        <draggable
          v-model="surveyQuestion.surveyQuestionAnswers"
          :animation="300"
          handle=".cursor-move"
        >
          <template v-for="(surveysQuestionsAnswer, key) in surveyQuestion.surveyQuestionAnswers">
            <b-col
              class="mtm-4 pt-0 mb-0 pb-0"
              cols="12"
              v-if="surveyQuestion.surveyQuestionAnswers && surveyQuestion.questionType !== 1"
              :key="key"
            >
              <surveys-questions-answers
                :surveys-questions-answer="surveysQuestionsAnswer"
                :question-type="surveyQuestion.questionType"
                :answer-key="key"
                :remove-item-collection="removeItemCollection"
              />
            </b-col>
          </template>
        </draggable>
      </b-col>
      <b-col cols="12" v-if="surveyQuestion.questionType === 2 || surveyQuestion.questionType === 3">
        <b-button variant="link" size="sm" class="p-0" @click="addNewItemCollection('surveysQuestionsAnswer')">
          <i class="fa fa-plus mr-2"></i> {{ $t("views.surveys.form.addAnswer") }}
        </b-button>
      </b-col>
      <b-col cols="12" v-if="surveyQuestion.questionType === 4">
        <b-form-group :label="$t('views.surveys.form.allowedExtensions')">
          <b-form-input
            v-model="surveyQuestion.allowedExtensions"
            name="allowedExtensions"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SurveysQuestionsAnswers from './surveysQuestionsAnswers'
import draggable from 'vuedraggable'

export default {
  name: 'surveysQuestions',
  components: {
    SurveysQuestionsAnswers,
    draggable
  },
  data () {
    return {
      questionTypeOptions: [
        { text: this.$t('views.surveys.form.questionTypeDescription'), value: 1, icon: 'mdi-text' },
        { text: this.$t('views.surveys.form.questionTypeOneAnswer'), value: 2, icon: 'mdi-radiobox-marked' },
        { text: this.$t('views.surveys.form.questionTypeManyAnswers'), value: 3, icon: 'mdi-checkbox-outline' },
        { text: this.$t('views.surveys.form.questionTypeAttachment'), value: 4, icon: 'mdi-paperclip' }
      ],
      rules: [
        value => {
          if (value) return true
          return this.$t('notifications.onSubmit.fieldIsRequired')
        }
      ]
    }
  },
  props: {
    surveyQuestion: {
      type: Object,
      required: true
    }
  },
  methods: {
    addNewItemCollection (type) {
      let objectGD
      if (type === 'surveysQuestionsAnswer') {
        if (this.surveyQuestion.surveyQuestionAnswers === null || this.surveyQuestion.surveyQuestionAnswers === undefined) {
          this.surveyQuestion.surveyQuestionAnswers = []
        }
        objectGD = {
          answerDescription: ''
        }
        this.surveyQuestion.surveyQuestionAnswers.push(objectGD)
      }
    },
    removeItemCollection (itemIndex, type) {
      if (type === 'surveysQuestionsAnswer') {
        this.surveyQuestion.surveyQuestionAnswers.splice(itemIndex, 1)
      }
    }
  }
}
</script>
